export async function rolesCreateUseCase(data, roleRepository) {
    const result = await roleRepository.create(data);
    
    const role = await new roleRepository.model(result.data.success.arguments);

    if (!role.isValid()) {
        throw new Error("rol inválido");
    }

    return result;
}